export enum ConnectorType {
    Connector = 'connector',
    Base = 'base',
    PipeFastening = 'pipeFastening',
}

export class UniversalConnectorModel {
    connectorType: ConnectorType;
    _id: string;
    articleNumber: number;
    name: string;
    description: string;
    system: string;
    corrosionProtection: string;
    picture: string;
    stepFile: string;
    connectorUsageType: string;
    pipeFasteningGroupId: number;

    constructor(connectorType,
        id = '',
        name = '',
        articleNumber = null,
        description = '',
        system = '',
        corrosionProtection = '',
        picture = '',
        stepFile = '',
        connectorUsageType = 'CHANNEL_CONNECTOR_TYPE',
    pipeFasteningGroupId = null) {
            this.connectorType = connectorType;
            this._id = id;
            this.articleNumber = articleNumber;
            this.description = description;
            this.system = system;
            this.corrosionProtection = corrosionProtection;
            this.name = name;
            this.picture = '';
            this.stepFile = '';
            this.connectorUsageType = connectorUsageType;
            this.pipeFasteningGroupId = pipeFasteningGroupId;
    }
}
